
export const API_URL = process.env.VUE_APP_ROOT_URL
export const DEFAULT_LANG_UUID = 'af01837f-aa5f-417e-bdfc-795f5f6c53cb'